import * as Yup from "yup";
import { emailValidationRegex } from "../../../../constants/regexStrings";
import phoneValidation from "../../../../common/components/phone-number-input-component/phone-validation";
import { isOnlyCountryCode } from "../../../../utils/utils";
interface FormValues {
  id: number;
  company: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  role: string;
}
export const initialValues = {
  company: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  role: "",
};
export const getInitialValues = (rowData?: any): FormValues => {
  return {
    id: rowData?.id ?? null,
    company: "",
    firstName: rowData?.first_name ?? "",
    lastName: rowData?.last_name ?? "",
    email: rowData?.email ?? "",
    phoneNumber: rowData?.phone_number ?? "",
    role: "",
  };
};
export const validationSchema = () =>
  Yup.object().shape({
    firstName: Yup.string().required("First Name cannot be empty"),
    lastName: Yup.string().required("Last Name cannot be empty"),
    email: Yup.string()
      .matches(emailValidationRegex, "Please enter a valid Email address")
      .required("Email cannot be empty")
      .max(150, "Email cannot be more than 150 characters"),
    role: Yup.number().required("Role cannot be empty"),
    phoneNumber: Yup.string().test(
      "valid-phone-check",
      "Please enter a valid phone number",
      function (value) {
        if (!value) return false;

        if (isOnlyCountryCode(value)) {
          return this.createError({
            message: "Phone number is required",
          });
        }

        if (!phoneValidation(value)) {
          return this.createError({
            message: "Please enter a valid phone number",
          });
        }

        return true;
      }
    ),
  });
